import axios from 'axios';
import Submission from '@/models/submission';
import store from '@/store';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_FILE_URL = process.env.VUE_APP_API_URL+"/files";

export default class SubmissionController {
  // Create a new submission
  static async createSubmission(subtaskId, files) {
    const userId = store.getters.userId;
    const teacher = store.getters.isTeacher;
    if (teacher) {
      throw new Error('Teachers cannot submit submissions. Please log in as a student.');
    }

    // Grace period for submission date, so it is properly picked by deadline if submitted in the last second
    const gracePeriod = 1000; // 1 second
    const effectiveTime = new Date(Date.now() - gracePeriod);
    // getTimezoneOffset returns the difference in minutes from local time to UTC (negative for timezones ahead of UTC)
    const timezoneOffset = effectiveTime.getTimezoneOffset() * 60000;
    // adjust the effective time to local time by subtracting the offset
    const localSubmissionTime = new Date(effectiveTime.getTime() - timezoneOffset);
    
    const submissionData = {
      subtask_id: subtaskId,
      student_id: userId,
      submission_date: localSubmissionTime.toISOString().replace('Z', '')
    };

    // Validate submissionData if needed
    Submission.validate(submissionData);

    const semester_id = store.getters.semesterId;
    const formData = new FormData();
    // Send submission_data as JSON string
    formData.append('submission_data', JSON.stringify(submissionData));
    
    // Append files to the same FormData
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await axios.post(
      `${API_FILE_URL}/save_submission_files/${semester_id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response;
  }
}

applyErrorHandlers(SubmissionController);